/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import utils from 'utils'
import cmsUtils from '../../utils/cmsUtils'
import { ShareThisWidget } from 'site/shareButtons/ShareThisWidget'

export function ShareThisWidgetView(props) {
  const item = props.item
  const cmsOption = props.cmsOption || {}
  
  const cssClass = utils.classNames('cms_item', item.cssClass || item.anchorName || '')
  const shareUrl = utils.site.fullUrl(window.location.pathname + window.location.search)
  
  // Get configuration from CMS item payload using cmsUtils
  const selectedSocialPlatforms = cmsUtils.payload(item, 'SelectedSocialPlatforms') || 'facebook,whatsapp,email'
  const selectedPlatforms = selectedSocialPlatforms.split(',').map(p => p.trim())
  
  const shareLabel = cmsUtils.payload(item, 'ShareButtonLabel') || 'SHARE THIS PAGE:'
  const buttonPosition = cmsUtils.payload(item, 'ButtonPosition') || 'center'
  
  // Debug logging
  console.log('ShareThisWidget - Item payload:', {
    selectedSocialPlatforms,
    selectedPlatforms,
    shareLabel,
    buttonPosition,
    itemPayloads: item.payloads
  })
  
  return (
    <div 
      className={cssClass} 
      data-cms-item-id={cmsOption.isCmsEdit && item.itemId} 
      id={item.anchorName}
    >
      <ShareThisWidget
        shareUrl={shareUrl}
        pageTitle={document.title}
        topLabel={shareLabel}
        selectedPlatforms={selectedPlatforms}
        buttonPosition={buttonPosition}
      />
    </div>
  )
}
